<script>
    export let row = {};
</script>

{#if row.approvers}
    {row.approvers}
{/if}
